import React from "react";
import styles from "assets/jss/material-dashboard-react/components/tablebaocaoStyle.js";
const useStyles = makeStyles(styles);
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import Config from "conFig.js";
const BCVantaitable = React.memo(function BCVantaitable(props) {
  const classes = useStyles();
  const { thangnam } = props;
  const [socontainer, setSocontainer] = React.useState(0);
  const [sodaukeo, setSodaukeo] = React.useState(0);
  const [sotaxitai, setSotaxitai] = React.useState(0);
  const [soxetai, setSoxetai] = React.useState(0);
  const [slvanchuyen_container, setSlvanchuyen_container] = React.useState(0);
  const [slvanchuyen_daukeo, setSlvanchuyen_daukeo] = React.useState(0);
  const [slvanchuyen_taxitai, setSlvanchuyen_taxitai] = React.useState(0);
  const [slvanchuyen_tai, setSlvanchuyen_tai] = React.useState(0);
  const [slluanchuyen_container, setSlluanchuyen_container] = React.useState(0);
  const [slluanchuyen_daukeo, setSlluanchuyen_daukeo] = React.useState(0);
  const [slluanchuyen_taxitai, setSlluanchuyen_taxitai] = React.useState(0);
  const [slluanchuyen_tai, setSlluanchuyen_tai] = React.useState(0);
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const getbaocao = () => {
    if (thangnam) {
      var thang = String(thangnam.$M + 1).padStart(2, "0") + "/" + thangnam.$y;
      var url =
        Config.backend +
        "/api/Phuongtien/bcslthhanghoa?thang=" +
        thang +
        "&username=" +
        username;
      fetch(url, obj)
        .then((res) => res.json())
        .then((data) => {
          if (data.length > 0) {
            setSocontainer(data[0].socontainer);
            setSodaukeo(data[0].sodaukeo);
            setSotaxitai(data[0].sotaxitai);
            setSoxetai(data[0].soxetai);
            setSlvanchuyen_container(data[0].slvanchuyen_container);
            setSlvanchuyen_daukeo(data[0].slvanchuyen_daukeo);
            setSlvanchuyen_taxitai(data[0].slvanchuyen_taxitai);
            setSlvanchuyen_tai(data[0].slvanchuyen_tai);
            setSlluanchuyen_container(data[0].slluanchuyen_container);
            setSlluanchuyen_daukeo(data[0].slluanchuyen_daukeo);
            setSlluanchuyen_taxitai(data[0].slluanchuyen_taxitai);
            setSlluanchuyen_tai(data[0].slluanchuyen_tai);
          }
        })
        .catch((error) => {
          console.error("Error fetching data: ", error);
        });
    }
  };
  React.useEffect(() => {
    getbaocao();
  }, [thangnam]);
  const renderTableHead = () => {
    return (
      <thead>
        <tr>
          <th className={classes.tablebc_th}>TT</th>
          <th className={classes.tablebc_th}>Chỉ tiêu</th>
          <th className={classes.tablebc_th}>Đơn vị</th>
          <th className={classes.tablebc_th}>Số lượng</th>
        </tr>
      </thead>
    );
  };
  const renderTableBody = () => {
    return (
      <tbody>
        <tr>
          <td className={classes.tablebc_td}>1</td>
          <td className={classes.tablebc_td}>Số lượng phương tiện</td>
          <td className={classes.tablebc_td}>xe</td>
          <td className={classes.tablebc_td}>
            {socontainer + sodaukeo + sotaxitai + soxetai}
          </td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}></td>
          <td className={classes.tablebc_td}>- Xe công-ten-nơ</td>
          <td className={classes.tablebc_td}>xe</td>
          <td className={classes.tablebc_td}>{socontainer}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}></td>
          <td className={classes.tablebc_td}>- Xe đầu kéo</td>
          <td className={classes.tablebc_td}>xe</td>
          <td className={classes.tablebc_td}>{sodaukeo}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}></td>
          <td className={classes.tablebc_td}>- Xe taxi tải</td>
          <td className={classes.tablebc_td}>xe</td>
          <td className={classes.tablebc_td}>{sotaxitai}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}></td>
          <td className={classes.tablebc_td}>- Xe tải khác</td>
          <td className={classes.tablebc_td}>xe</td>
          <td className={classes.tablebc_td}>{soxetai}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>2</td>
          <td className={classes.tablebc_td}>Sản lượng hàng hóa vận chuyển</td>
          <td className={classes.tablebc_td}>tấn</td>
          <td className={classes.tablebc_td}>
            {slvanchuyen_container +
              slvanchuyen_daukeo +
              slvanchuyen_taxitai +
              slvanchuyen_tai}
          </td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}></td>
          <td className={classes.tablebc_td}>- Xe công-ten-nơ</td>
          <td className={classes.tablebc_td}>tấn</td>
          <td className={classes.tablebc_td}>{slvanchuyen_container}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}></td>
          <td className={classes.tablebc_td}>- Xe đầu kéo</td>
          <td className={classes.tablebc_td}>tấn</td>
          <td className={classes.tablebc_td}>{slvanchuyen_daukeo}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}></td>
          <td className={classes.tablebc_td}>- Xe taxi tải</td>
          <td className={classes.tablebc_td}>tấn</td>
          <td className={classes.tablebc_td}>{slvanchuyen_taxitai}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}></td>
          <td className={classes.tablebc_td}>- Xe tải khác</td>
          <td className={classes.tablebc_td}>tấn</td>
          <td className={classes.tablebc_td}>{slvanchuyen_tai}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>3</td>
          <td className={classes.tablebc_td}>Sản lượng luân chuyển hàng hóa</td>
          <td className={classes.tablebc_td}>tấn.km</td>
          <td className={classes.tablebc_td}>
            {slluanchuyen_container +
              slluanchuyen_daukeo +
              slluanchuyen_taxitai +
              slluanchuyen_tai}
          </td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}></td>
          <td className={classes.tablebc_td}>- Xe công-ten-nơ</td>
          <td className={classes.tablebc_td}>tấn.km</td>
          <td className={classes.tablebc_td}>{slluanchuyen_container}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}></td>
          <td className={classes.tablebc_td}>- Xe đầu kéo</td>
          <td className={classes.tablebc_td}>tấn.km</td>
          <td className={classes.tablebc_td}>{slluanchuyen_daukeo}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}></td>
          <td className={classes.tablebc_td}>- Xe taxi tải</td>
          <td className={classes.tablebc_td}>tấn.km</td>
          <td className={classes.tablebc_td}>{slluanchuyen_taxitai}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}></td>
          <td className={classes.tablebc_td}>- Xe tải khác</td>
          <td className={classes.tablebc_td}>tấn.km</td>
          <td className={classes.tablebc_td}>{slluanchuyen_tai}</td>
        </tr>
      </tbody>
    );
  };
  var tHead = renderTableHead();
  var tBody = renderTableBody();
  return (
    <div className={classes.table} style={{ height: "350px" }}>
      <table id="baocaovantai" className={classes.tablebc}>
        {tHead}
        {tBody}
      </table>
    </div>
  );
});

BCVantaitable.propTypes = {
  thangnam: PropTypes.object,
};
export default BCVantaitable;
